/*
Model Name Corrections - Maps known typos to correct model names
This ensures that vehicles with typo'd model names show the correct name in dropdowns.
*/

// Mapping of incorrect model names (key) to correct model names (value)
// Format: brand|incorrectModel -> correctModel
export const MODEL_NAME_CORRECTIONS: Record<string, string> = {
  // Royal Enfield corrections
  'ROYAL ENFIELD|HYMALAYA': 'Himalayan', // typo: missing 'i'
  'ROYAL ENFIELD|HIMALAYA': 'Himalayan', // incomplete: missing 'n'
  'ROYAL ENFIELD|HIMALAYAN': 'Himalayan', // already correct

  // Add more brand|model corrections as needed
  // 'BRAND|INCORRECT': 'Correct',
}

/**
 * Gets the corrected model name for a given brand and model
 * @param brand - The vehicle brand (will be normalized to uppercase)
 * @param model - The model name (will be checked against corrections)
 * @returns The corrected model name, or original if no correction exists
 */
export function getCorrectedModelName(brand: string, model: string): string {
  if (!brand || !model) return model

  const key = `${brand.toUpperCase()}|${model.toUpperCase()}`
  const corrected = MODEL_NAME_CORRECTIONS[key]

  return corrected || model
}
